import _ from 'lodash';

import { Component, OnDestroy, ViewChild } from '@angular/core';
import { TeamService } from 'src/app/shared/services/team.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { TeamEditDetailsComponent } from './team-edit-details.component';

@Component({
  selector: 'app-team-edit',
  templateUrl: 'team-edit.component.html',
  standalone: false
})
export class TeamEditComponent implements OnDestroy {
  private errorMessage: any;
  private subscriptions: Array<Subscription> = new Array<Subscription>();

  @ViewChild(TeamEditDetailsComponent)
  public editDetails: TeamEditDetailsComponent;
  public saving: boolean;

  constructor(
    public dialogRef: MatDialogRef<TeamEditComponent>,
    private teamService: TeamService
  ) {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  updateTeam() {
    if (!this.saving) {
      if (this.editDetails.valid) {
        this.saving = true;
        this.subscriptions.push(
          this.teamService.team.subscribe(
            (team) => {
              if (team) {
                this.dialogRef.close('yes');
              }
            },
            (error) => (this.errorMessage = <any>error)
          )
        );
        this.teamService.updateTeam(this.editDetails.outputTeam);
      }
    }
  }
}
